import React from "react";
import { Navigate, Outlet } from "react-router";
import { useAuth } from "../../hooks/useAuth";

const PrivateRouteSchedule = () => {
  const { user } = useAuth();
  const editor = user?.profiles[0]?.editor?.findIndex(
    (edit) => edit.id === "ff1be56d-68f5-4e45-8af5-85cb9bcd804b"
  );

  return editor > -1 ? <Outlet /> : <Navigate to="/login/redirect/*videoteca" />;
};

export default PrivateRouteSchedule;
